import React, { useState } from "react";
import styled from "@emotion/styled";
import { planTypeAmount } from "components/Travel/function";
import FullPopup from "components/Common/Mobile/PopupFull";
import BottomPopup from "components/Common/Mobile/PopupBottom";
import PopupPortal from "components/Common/Shared/PopupPortal";
import { specialGuarantees } from "discription";
import iconInfo from "images/icon-info.svg";

interface PlanPopupProps {
  title: string;
  togglePopup: any;
  contents: any;
}

const GuaranteePopup: React.FunctionComponent<PlanPopupProps> = ({
  title,
  togglePopup,
  contents
}) => {
  const [isShowHalfPopup, toggleHalfPopup] = useState(false);
  const [descData, setDescContent] = useState({
    title: "",
    desc: ""
  });

  const onClickTitle = (data: any) => {
    setDescContent({
      title: data.title,
      desc: data.desc
    });
    toggleHalfPopup(!isShowHalfPopup);
  };

  return (
    <FullPopup title={`보장내용 확인 (${title})`} onOk={togglePopup}>
      <div>
        <GuaranteeList>
          {specialGuarantees.v2.data.map((guaranteeItem: any, i: number) => (
            <li key={`guarantee${i}`}>
              <GuaranteeTitle onClick={() => onClickTitle(guaranteeItem)}>
                <span className="name">
                  {guaranteeItem.title}
                  <span className="icon">
                    <img src={iconInfo} alt="자세히 보기" />
                  </span>
                </span>
                <span className="price">{planTypeAmount(contents, i)}</span>
              </GuaranteeTitle>
            </li>
          ))}
        </GuaranteeList>
        {isShowHalfPopup && (
          <PopupPortal>
            <BottomPopup
              title={descData.title}
              onClose={() => toggleHalfPopup(!isShowHalfPopup)}
            >
              <p>{descData.desc}</p>
            </BottomPopup>
          </PopupPortal>
        )}
      </div>
    </FullPopup>
  );
};

const GuaranteeList = styled.ul`
  border-bottom: 1px solid ${props => props.theme.colors.divider2};

  > li {
    padding: 15px 20px 14px;
    border-top: 1px solid ${props => props.theme.colors.divider2};
  }

  > li:first-of-type {
    border-top-color: ${props => props.theme.colors.divider};
  }
`;

const GuaranteeTitle = styled.p`
  display: flex;
  justify-content: space-between;
  align-items: center;

  .name {
    font-weight: ${props => props.theme.weight.bolder};
    white-space: pre-line;
  }

  .icon {
    margin-left: 4px;
  }

  .price {
    margin-left: 20px;
  }
`;

export default GuaranteePopup;
